import InfoIcon from "@mui/icons-material/Info";
import { Box, Grid, Tooltip, Typography, styled } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { imagesList } from "../../constants/index";

const CustomTCOCard = styled(Box)(({ theme }) => ({
  ".Mui-Tooltip-touch": {
    width: "150px",
  },
}));

const TCOCard = ({
  mainColor,
  secondaryColor,
  imageName,
  vehicleType,
  prices,
  kms,
  years,
}) => {
  return (
    <CustomTCOCard>
      <Box>
        <Box style={{ background: mainColor, padding: "5px" }}>
          <Typography
            style={{
              fontSize: "12px",
              fontWeight: "400",
              color: "#ffffff",
            }}
          >
            {vehicleType}
          </Typography>
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={4}>
              <Box>
                <LazyLoadImage
                  height={"35px"}
                  src={imagesList.doubleCoin}
                  alt="saving coins"
                />
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Box>
                <Typography
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#ffffff",
                  }}
                >
                  ₹
                  {(
                    prices?.onRoadPrices +
                    prices?.fuelCost +
                    prices?.maintenance -
                    prices?.resale
                  ).toLocaleString("en-In")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            background: secondaryColor,
            padding: "8px 2px",
          }}
        >
          <Box>
            <LazyLoadImage
              width={"100%"}
              height={"100px"}
              src={imagesList[imageName]}
              alt={imageName}
            />
          </Box>
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={3}>
              <Typography
                style={{
                  fontSize: "25px",
                  color: mainColor,
                  paddingLeft: "2px",
                }}
              >
                {vehicleType === "Turno Electric Vehicle" ? "🚙" : "🚚"}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Box>
                <Typography style={{ fontSize: "12px", fontWeight: "400" }}>
                  Ex-Showroom price
                </Typography>
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontSize: "18px", fontWeight: "700" }}>
                    ₹ {(prices?.exShowRoomPrice).toLocaleString("en-In")}
                  </Typography>
                  {vehicleType === "Turno Electric Vehicle" && (
                    <Tooltip
                      title={
                        <>
                          <Typography style={{ fontSize: "10px" }}>
                            Price shown after
                          </Typography>
                          <Typography style={{ fontSize: "10px" }}>
                            after subsidy
                          </Typography>
                        </>
                      }
                    >
                      <InfoIcon style={{ fontSize: "15px" }}> </InfoIcon>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            background: secondaryColor,
            padding: "8px 2px",
          }}
        >
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={3}>
              <Typography
                style={{
                  fontSize: "25px",
                  color: mainColor,
                  paddingLeft: "2px",
                }}
              >
                {vehicleType === "Turno Electric Vehicle" ? "🔋" : "⛽"}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Box>
                <Typography style={{ fontSize: "12px", fontWeight: "400" }}>
                  {vehicleType !== "Turno Electric Vehicle"
                    ? "Fuel Cost"
                    : " Charging Cost"}
                </Typography>
                <Typography style={{ fontSize: "18px", fontWeight: "700" }}>
                  ₹ {(prices?.fuelCost).toLocaleString("en-In")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            background: secondaryColor,
            padding: "8px 2px",
          }}
        >
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={3}>
              <Typography
                style={{
                  fontSize: "25px",
                  color: mainColor,
                  paddingLeft: "2px",
                }}
              >
                {vehicleType === "Turno Electric Vehicle"
                  ? "😎"
                  : kms > 100 || years > 4
                    ? "😰"
                    : kms > 80 || years > 3
                      ? "😞"
                      : "🙂"}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Box>
                <Typography style={{ fontSize: "12px", fontWeight: "400" }}>
                  Maintenance
                </Typography>
                <Typography style={{ fontSize: "18px", fontWeight: "700" }}>
                  ₹ {(prices?.maintenance).toLocaleString("en-In")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            background: secondaryColor,
            padding: "8px 2px",
          }}
        >
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={3}>
              <Typography
                style={{
                  fontSize: "25px",
                  color: mainColor,
                  paddingLeft: "2px",
                }}
              >
                {vehicleType === "Turno Electric Vehicle"
                  ? "😎"
                  : kms > 100 || years > 4
                    ? "😭"
                    : kms > 80 || years > 3
                      ? "😣"
                      : "😟"}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Box>
                <Typography style={{ fontSize: "12px", fontWeight: "400" }}>
                  Exchange Value
                </Typography>
                <Typography style={{ fontSize: "18px", fontWeight: "700" }}>
                  ₹ {(prices?.resale).toLocaleString("en-In")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box
          style={{
            background: secondaryColor,
            padding: "8px 2px",
          }}
        >
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={3}>
              <Typography
                style={{
                  fontSize: "25px",
                  color: mainColor,
                  paddingLeft: "2px",
                }}
              >
                {vehicleType === "Turno Electric Vehicle" ? "😃" : "😭"}
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <Box>
                <Typography style={{ fontSize: "12px", fontWeight: "400" }}>
                  On Road Price
                </Typography>
                <Typography style={{ fontSize: "18px", fontWeight: "700" }}>
                  ₹ {(prices?.onRoadPrices).toLocaleString("en-In")}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </CustomTCOCard>
  );
};

export default TCOCard;
